import { MegaNavLink } from '@components/common/types'
import { ChevronDown, ChevronUp } from '@components/icons'
import ArrowRightSmall from '@components/icons/ArrowRightSmall'
import { useUI } from '@components/ui/context'
import Link from '@components/ui/Link'
import cn from 'clsx'
import { FC, useState } from 'react'

interface props {
  title: string
  link?: string
  links?: MegaNavLink[]
  handleCloseMegaMenu: Function
  isFirstColumn?: boolean
}

const NavColumnList: FC<props> = ({
  title,
  link,
  links,
  handleCloseMegaMenu,
  isFirstColumn,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const { closeSidebar } = useUI()

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen)
  }

  const closeMenu = () => {
    handleCloseMegaMenu()
    closeSidebar()
  }

  return (
    <>
      {isFirstColumn ? (
        // First column: col.title as link on desktop; mobile handled by MenuSidebarView
        <div className="hidden lg:block mb-5" onClick={closeMenu}>
          {link ? (
            <Link
              className="body-2-bold text-dark-grey hover:opacity-75 flex items-center gap-2"
              href={link}
              prefetch={false}
            >
              <span>{title}</span>
              <span className="flex-shrink-0">
                <ArrowRightSmall />
              </span>
            </Link>
          ) : (
            <span className="body-2-bold text-dark-grey flex items-center gap-2">
              {title}
            </span>
          )}
        </div>
      ) : (
        <>
          <div className="hidden lg:block body-3-bold uppercase text-darkest-grey mb-5">
            {link ? (
              <Link href={link} prefetch={false}>
                {title}
              </Link>
            ) : (
              <span>{title}</span>
            )}
          </div>
          <button
            className="lg:hidden body-1 text-dark-grey w-full flex justify-between focus:outline-none"
            onClick={toggleDrawer}
          >
            <div>{title}</div>
            <div className="lg:hidden mt-2">
              {isDrawerOpen ? <ChevronUp /> : <ChevronDown />}
            </div>
          </button>
        </>
      )}
      <ul
        className={cn(
          'py-4 lg:py-0 lg:!flex lg:flex-col lg:flex-wrap lg:max-h-[340px]',
          {
            // First column always visible on mobile; other columns toggle
            'hidden lg:block': !isFirstColumn && !isDrawerOpen,
          }
        )}
      >
        {links?.map((link) => (
          <li
            key={link.Label}
            className="body-2 text-dark-grey pl-0 hover:opacity-75 mb-4"
            onClick={closeMenu}
          >
            <Link href={link.Link} prefetch={false}>
              {link.Label}
            </Link>
          </li>
        ))}
        {!isFirstColumn && link && !!links?.length && (
          <li
            className="body-2-bold text-dark-grey pl-0 hover:opacity-75 mb-4"
            onClick={closeMenu}
          >
            <Link
              className="flex flex-row items-center gap-2"
              href={link}
              prefetch={false}
            >
              <span>Shop All</span>
              <ArrowRightSmall />
            </Link>
          </li>
        )}
      </ul>
    </>
  )
}

export default NavColumnList
